import React, { useEffect } from 'react';
import LoadingPrivacyControls from './LoadingPrivacyControls';
import LegalDocumentLinks from './LegalDocumentLinks';
import { appPath } from '../../utils/paths';
import identity from './legalIdentity.json';

export default function PrivacyDataPage() {
  useEffect(() => { document.title = 'Data controls — Meet Joz'; }, []);
  return <main style={{position:'fixed',inset:0,overflowY:'auto',background:'#101010',color:'#f5f5f5',padding:'clamp(20px, 5vw, 64px)',boxSizing:'border-box',font:'16px/1.6 Arial, sans-serif'}}>
    <div style={{maxWidth:760,margin:'0 auto'}}>
      <a href={appPath('/')} style={{color:'inherit',pointerEvents:'auto',animation:'none'}}>Meet Joz</a>
      <h1>Data controls</h1>
      <p>For a session still open in another tab, use Joz MAXX → ⓘ → Privacy in that tab. This page does not transfer its permissions or private credentials.</p>
      <p>To manage earlier saved data, enter the Data Key from your downloaded key file below. Opening this page does not create a feature session or enable online features.</p>
      <LoadingPrivacyControls embedded dataOnly />
      <p>Lost your key, or looking for older records? Contact <a style={{color:'inherit',pointerEvents:'auto',animation:'none'}} href={`mailto:${identity.email}`}>{identity.email}</a>. Include an approximate date and the feature you used. Do not email passwords or a Data Key.</p>
      <LegalDocumentLinks />
    </div>
  </main>;
}
